<div class="cipo--height--full cipo--overflow--auto" fxLayout="column">
    <div fxFlex="grow" class="cipo--overflow--auto">
        @if (loading()) {
            <div fxLayout="row wrap" fxLayoutGap="16px grid" style="width: 100%">
                @for (item of skeletonItems(); track item) {
                    <div fxFlex="0 1 calc(50%)" fxFlex.xs="100%">
                        <ngx-skeleton-loader
                            class="cipo--width--full"
                            [theme]="{ height: '340px', margin: 0, display: 'flex', 'border-radius': '8px' }" />
                    </div>
                }
            </div>
        } @else if (!cards().length) {
            <div class="m-t-xl">
                <cipo-not-found />
            </div>
        } @else {
            @for (card of cards(); track card.entity_instance_id) {
                <div class="gridItemsWrapper">
                    <div class="gridItem">
                        <app-data-card-view
                            data-testid="datalist-card"
                            [card]="card"
                            [actions]="actions()"
                            (click)="cardClickInternal(card)" />
                    </div>
                </div>
            }
        }
    </div>
    <div fxFlex="none">
        @if (options().pagination) {
            @let serverPagination = serverPaginate();
            @if (serverPagination) {
                <div fxLayout fxLayoutAlign="end center" class="cipo-text--medium-sm cipo-bg--white">
                    @if (
                        cards()?.length && !options().hidePagesLoaded && !isLoading() && serverPagination.pagesCount > 0
                    ) {
                        <p
                            fxFlex="none"
                            class="cipo-text--medium-sm p-r cipo--border-right--solid"
                            data-testid="paged-datalist-page-loaded">
                            {{
                                "general.table.pageLoaded"
                                    | translate
                                        : {
                                              page: serverPagination.pageIndex + 1,
                                              total: serverPagination.pagesCount,
                                          }
                            }}
                        </p>
                    }
                    <mat-paginator
                        #serverPaginator
                        data-testid="datalist-paginator datalist-paginator-server"
                        showFirstLastButtons
                        [style]="{ display: !cards().length && !loading() ? 'none' : 'block' }"
                        [pageIndex]="serverPagination.pageIndex"
                        [pageSize]="serverPagination.pageSize"
                        [pageSizeOptions]="serverPagination.pageSizeOptions"
                        [length]="serverPagination.length"
                        [disabled]="loading()"
                        (page)="paginationChange($event)" />
                </div>
            } @else {
                <mat-paginator
                    data-testid="datalist-paginator datalist-paginator-client"
                    [style]="{ display: !cards.length && !loading() ? 'none' : 'block' }" />
            }
        }
    </div>
</div>
